/* QUESTIONS */
import * as AOS from "aos";

import 'aos/dist/aos.css';

window.addEventListener("load", () => {
  AOS.init({
    once: true,
  });
});

import { Countdown } from "../components/trivia/countdown";
import { StartTrivia } from "../components/trivia/trivia";
import { optionSelect } from "../components/trivia/optionSelect"
import { viewShow } from "../components/trivia/functions"

import { AudioButton } from "../components/trivia/Audio"

declare global {
  interface Window {
    dama: any;
    datalayer: any;
    SHA256: any;
    // drupalSettings: any;
    statusPermits: any;
    welcomeTrivia: any;
    activeSound: boolean;
  }
}

/**
 * Module Question
 *
 */
export const Question = (activeSound: boolean) => {

  startTrivia(activeSound)
};

function startTrivia(activeSound: boolean) {

  window.activeSound = activeSound;
  let counter = document.getElementById("triviaTime");
  let time = counter.dataset.time;
  let newTime = time ? parseInt(time) : 10;
  welcomeTrivia(newTime);
  optionSelect();

  AudioButton.init();
}

/**
 *
 * @param newTime
 */
const welcomeTrivia = (newTime: number) => {
  viewShow(2)
  fetch(`${window.origin}/trivia/start_date/${window.drupalSettings.user.uid}`, { method: 'POST' })
      .then(res => res.json())
      .then(data => {
        // console.log(data);
        if (data.status.message === 'actualizado') {
          if (window.statusPermits == "undefined" || window.statusPermits == null) {
            window.statusPermits = true;
          }
          // Show Trivia
          showTrivia();
          // Countdown Initialized
          if (window.activeSound) Countdown.init(newTime);
          // Trivia Initialized
          StartTrivia();
          addLetterAnswer()

        }
      })

  // const btnStartTrivia = document.querySelector("#welcomeTrivia .btn_st") as HTMLAnchorElement
  // btnStartTrivia.addEventListener("click", () => {
  //   /**
  //  * Click to start trivia
  //  */
    
  // })
  // btnStartTrivia.click()
}

/**
 *
 * @param welcomeTriviaCont
 */


const showTrivia = () => {
  let triviaCont = document.getElementById("triviaContainer");
  viewShow(2)
  setTimeout(() => triviaCont.classList.add("trivia--started"), 300);
};

const addLetterAnswer = () =>{
  const index = document.querySelectorAll("fieldset.trivia__answers")

  const letter: any = {
    '0' : 'a&#41',
    '1' : 'b&#41',
    '2' : 'c&#41',
    '3' : 'd&#41',
    '4' : 'e&#41',
    '5' : 'f&#41',
    '6' : 'g&#41',
    '7' : 'h&#41',
    '8' : 'i&#41',
    '9' : 'j&#41',
    '10': 'k&#41',
    '11': 'l&#41',
  }

  index.forEach((item) =>{
    const options = item.querySelectorAll(".textQuestion-letter")
    options.forEach((option, index) =>{
      option.textContent = letter[index]
    })
  })
}